module.exports = __webpack_public_path__ + "img/alxq6.aa9eb7bb.png";